<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      validation-provider(name="valor" :rules="rules.value" v-slot="{ errors }")
        label Valor de la propiedad
        v-text-field-money(
          v-model="data.value"
          :error-messages="errors"
          :disabled="disabled"
          name="valor"
        )
</template>

<script>
  import formMixin from '@/mixins/form-mixin';
  import PENtoUSD from '@/utils/pen-to-usd';

  const DEFAULT_VALUES = {
    currencyId: 1,
    value: null,
  };

  export default {
    name: 'property-form',

    mixins: [
      formMixin(),
    ],

    props: {
      product: { type: String },
      populatedData: { type: Object },
    },

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },

    computed: {
      rules() {
        const currencyId = this.data.currencyId;

        const min_value = 17e4;
        const max_value = 2e7;

        return {
          value: {
            required: true,
            min_value: currencyId === 1 ? min_value : parseInt(PENtoUSD(min_value)),
            max_value: currencyId === 1 ? max_value : parseInt(PENtoUSD(max_value)),
          },
        };
      },
    },
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0
</style>